export const ASC = 'asc'
export const DESC = 'desc'
export const UNSET = undefined

export type SortingDirection = typeof ASC | typeof DESC | typeof UNSET

export type Sorting = {
  [key: string]: SortingDirection
}
